export class ButtonBadge {
    constructor() { }

    private isExpanded: boolean = false;
    private ajaxBadges: any = $("a[data-badge-url]");
    private titles: any = $(".badge-button-title");
    private expandButton: any = $(".badge-button-expand");

    public async Init() {
        this.expandButton.click(() => this.Toggle());
        setTimeout(() => { this.Colapse(); }, 1500);

        for (let i = 0; i < this.ajaxBadges.length; i++) {
            const badgeEl = $(this.ajaxBadges[i]);
            const url = badgeEl.attr("data-badge-url");
             
            try {
                const count = await $.ajax({ url: url, cache: false });
                if (count < 10) {
                    badgeEl.children('.badge-button-count').first().html(count);
                }
                else {
                    badgeEl.children('.badge-button-count').first().html('9+');
                }
            }
            catch (error: any) {
                badgeEl.children('.badge-button-count').first().html('<i class="fa fa-exclamation badge-button-count-error" aria-hidden="true"></i>');
            }
        }
    }

    public Toggle() {
        if (this.isExpanded) this.Colapse();
        else this.Expand();
    }

    public Expand() {
        this.titles.show(500);
        this.expandButton.fadeIn(500).addClass("mirror-text", 500);
        this.isExpanded = true;
    }

    public Colapse() {
        this.titles.hide(500);
        this.expandButton.fadeIn(500).removeClass("mirror-text", 500);
        this.isExpanded = false;
    }
};